import { Injectable } from '@angular/core';
import { EntityType } from '../../shared/enums/entity-type.enum';

import { APP_CONFIG } from '../../app.config';
import { ConfirmationResponse } from '../../shared/models/communication-response.model';
import { RequestService } from '../../shared/services/request.service';
import { QueueActionType } from './enums/queue-action-type.enum';
import { QueueStatus } from './enums/queue-status.enum';
import { QueueConfig } from './models/queue-config.model';
import { Queue } from './models/queue.model';

@Injectable()
export class QueueService {
  constructor(private requestService: RequestService) {}

  async getQueue(
    entityId: number,
    entityType: EntityType,
    isOpen: boolean,
    page?: number,
    size?: number
  ): Promise<Array<Queue>> {
    const params: any = {
      entityType: entityType,
      entityId: entityId,
      status: `${QueueStatus.IN_QUEUE['code']},${QueueStatus.NOTIFIED['code']}`,
      sort: 'ASC',
    };
    if (!isOpen) {
      params.status = `${QueueStatus.CONFIRMED['code']},${QueueStatus.NO_SHOW['code']},${QueueStatus.CANCELED_BY_CUSTOMER['code']},${QueueStatus.CANCELED_BY_STORE['code']}`;
      params.page = page;
      params.size = size;
      params.sort = 'DESC';
    }
    // /v1/protected/queue?entityType=STORE&entityId=8&status=NO_SHOW,IN_QUEUE&page=1&sort=ASC&orderBy=quota&endDate=2022-08-04T20:33:11&startDate=2022-07-04T20:33:11
    const urlRequest =
      APP_CONFIG.WEBSERVICE.QUEUE + '?' + this.requestService.buildUrlParams(params);
    let response = await this.requestService.getData(urlRequest);
    const queue: Array<Queue> = [];
    if (response && response.length > 0) {
      for (const q of response) {
        queue.push(new Queue(q));
      }
    }
    console.log(queue);
    return queue || [];
  }

  async saveQueue(queue: Queue): Promise<ConfirmationResponse> {
    if (queue.uuid) {
      return await this.requestService.putData(
        `${APP_CONFIG.WEBSERVICE.QUEUE}/${queue.uuid}`,
        queue.toJson()
      );
    } else {
      return await this.requestService.postData(APP_CONFIG.WEBSERVICE.QUEUE, queue.toJson());
    }
  }

  async actionQueue(uuid: string, action: QueueActionType): Promise<ConfirmationResponse> {
    let urlRequest: string;
    switch (action) {
      case QueueActionType.CALL:
        urlRequest = APP_CONFIG.WEBSERVICE.NOTIFY_QUEUE;
        break;

      case QueueActionType.CONFIRM:
        urlRequest = APP_CONFIG.WEBSERVICE.CONFIRM_QUEUE;
        break;

      case QueueActionType.NO_SHOW:
        urlRequest = APP_CONFIG.WEBSERVICE.NOSHOW_QUEUE;
        break;

      case QueueActionType.CANCEL:
        urlRequest = APP_CONFIG.WEBSERVICE.CANCEL_QUEUE;
        break;

      default:
        break;
    }
    urlRequest = this.requestService.buildUrlPathParams({ uuid: uuid }, urlRequest);
    return await this.requestService.patchData(urlRequest);
  }

  async callNext(entityId: number, entityType: EntityType): Promise<ConfirmationResponse> {
    const params: any = {
      entityType: entityType,
      entityId: entityId,
    };
    const urlRequest =
      APP_CONFIG.WEBSERVICE.CALL_NEXT + '?' + this.requestService.buildUrlParams(params);
    return await this.requestService.getData(urlRequest);
  }

  async rollbackStatus(uuid: string): Promise<void> {
    let urlRequest = this.requestService.buildUrlPathParams(
      { uuid: uuid },
      APP_CONFIG.WEBSERVICE.ROLLBACK_STATUS
    );
    return await this.requestService.patchData(urlRequest);
  }

  // CONFIG
  // ----------------

  async getQueueConfig(storeId: number, entity: EntityType = EntityType.STORE): Promise<any> {
    const urlRequest: string = `${APP_CONFIG.WEBSERVICE.GET_QUEUE_CONFIG}?entity=${entity}&entityId=${storeId}`;
    return await this.requestService.getData(urlRequest);
  }

  async saveConfig(config: QueueConfig): Promise<void> {
    if (config.id) {
      return await this.requestService.putData(APP_CONFIG.WEBSERVICE.QUEUE_CONFIG, config.toJson());
    } else {
      return await this.requestService.postData(
        APP_CONFIG.WEBSERVICE.QUEUE_CONFIG,
        config.toJson()
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/queue/queue.service.ts